import React, {Component} from 'react';

class GoogleUpload extends Component {

    componentDidMount(){
        let _this = this;
        window.___gcfg = {
            lang: 'en-US'
        };
        const accessToken = sessionStorage.getItem('accessToken');

        if (accessToken) {
            window.gapi.savetodrive.render(this.props.divId, {
                src: this.props.dataSource,
                filename: this.props.fileName,
                sitename: this.props.siteName,
                authuser: 0
            });
        } else {
        window.gapi.savetodrive.render(_this.props.divId, {
            src: _this.props.dataSource,
            filename: _this.props.fileName,
            sitename: _this.props.siteName
        });}
    }
    render() {
        return (
            <div className="form-group" style={{marginLeft: "5px"}}>
                <div id="savetodrive-div"></div>
            </div>
        )
    }
}
export default GoogleUpload;


// WEBPACK FOOTER //
// ./src/components/template/GoogleUpload.js